module.exports = __webpack_public_path__ + "img/invite-success.f4c57c4.svg";